<template>
  <div class="relative flex flex-col select-none">
    <div
      class="
        desktop:absolute
        flex
        mobile:flex-initial
        items-center
        self-center
        h-20
        space-x-2
      "
    >
      <div
        v-for="value in maxValue"
        :key="value"
        class="cursor-pointer"
        @click="!disabled ? onChange(value) : void 0"
      >
        <IconStar
          class="transition-colors"
          :class="value <= modelValue ? 'text-lime' : 'text-gray-1'"
        />
      </div>
    </div>
    <div class="flex items-center justify-between desktop:h-20">
      <div class="heading-2 whitespace-nowrap">
        {{ $t('ratingForm.minValueLabel') }}
      </div>
      <div class="heading-2 whitespace-nowrap">
        {{ $t('ratingForm.maxValueLabel') }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Mixins } from 'vue-property-decorator';
import RatingSelectComponentMixin from '@/mixins/ratingSelectComponentMixin';
@Component
export default class RatingSelect extends Mixins(RatingSelectComponentMixin) {
  @Prop({ type: Number, default: 5 }) maxValue!: number;
}
</script>
